// Pre-season Player & Team FPL Projections Data (Fetched from Tlog API Leaderboard)
export const TEAM_PROJECTIONS_DATA = [
  {
    "clubId": "10",
    "clubName": "Real MaQuiz Athletic FC",
    "managerName": "Nick Lemare",
    "totalPts": 1410.7,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 223,
        "name": "Jean-Philippe Mateta",
        "webName": "Mateta",
        "position": "FWD",
        "fplTeam": "CRY",
        "fplPos": "FWD",
        "fplPrice": 6.5,
        "mins": 1637.0,
        "goals": 9.4,
        "assists": 1.5,
        "cleanSheets": 0.0,
        "bonus": 12.2,
        "yc": 2.6,
        "pts": 98.6,
        "value": 15.2,
        "matched": true,
        "matchName": "Mateta"
      },
      {
        "playerId": 15,
        "name": "Martin \u00d8degaard",
        "webName": "\u00d8degaard",
        "position": "MID",
        "fplTeam": "ARS",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 2585.0,
        "goals": 5.5,
        "assists": 10.1,
        "cleanSheets": 11.8,
        "bonus": 12.7,
        "yc": 3.0,
        "pts": 144.4,
        "value": 22.2,
        "matched": true,
        "matchName": "Odegaard"
      },
      {
        "playerId": 335,
        "name": "Anton Stach",
        "webName": "Stach",
        "position": "MID",
        "fplTeam": "LEE",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2791.0,
        "goals": 4.7,
        "assists": 7.8,
        "cleanSheets": 7.0,
        "bonus": 14.0,
        "yc": 6.4,
        "pts": 145.4,
        "value": 24.2,
        "matched": true,
        "matchName": "Stach"
      },
      {
        "playerId": 229,
        "name": "James Tarkowski",
        "webName": "Tarkowski",
        "position": "DEF",
        "fplTeam": "EVE",
        "fplPos": "DEF",
        "fplPrice": 6.0,
        "mins": 3115.0,
        "goals": 1.6,
        "assists": 2.9,
        "cleanSheets": 7.9,
        "bonus": 9.8,
        "yc": 8.4,
        "pts": 137.6,
        "value": 22.9,
        "matched": true,
        "matchName": "Tarkowski"
      },
      {
        "playerId": 481,
        "name": "Elliot Anderson",
        "webName": "Anderson",
        "position": "MID",
        "fplTeam": "MCI",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 2968.0,
        "goals": 2.6,
        "assists": 6.2,
        "cleanSheets": 11.2,
        "bonus": 10.1,
        "yc": 7.4,
        "pts": 131.8,
        "value": 20.3,
        "matched": true,
        "matchName": "Anderson"
      },
      {
        "playerId": 112,
        "name": "Jan Paul Van Hecke",
        "webName": "Van Hecke",
        "position": "DEF",
        "fplTeam": "TOT",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 2865.0,
        "goals": 2.3,
        "assists": 2.1,
        "cleanSheets": 8.4,
        "bonus": 7.8,
        "yc": 7.5,
        "pts": 128.3,
        "value": 25.7,
        "matched": true,
        "matchName": "Van Hecke"
      },
      {
        "playerId": 208,
        "name": "Isma\u00efla Sarr",
        "webName": "Sarr",
        "position": "MID",
        "fplTeam": "CRY",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 2866.0,
        "goals": 11.2,
        "assists": 5.4,
        "cleanSheets": 6.3,
        "bonus": 13.4,
        "yc": 4.7,
        "pts": 156.7,
        "value": 24.1,
        "matched": true,
        "matchName": "Sarr"
      },
      {
        "playerId": 586,
        "name": "Nobel Mendy",
        "webName": "Mendy",
        "position": "DEF",
        "fplTeam": "HUL",
        "fplPos": "DEF",
        "fplPrice": 4.0,
        "mins": 2650.0,
        "goals": 0.9,
        "assists": 0.9,
        "cleanSheets": 3.5,
        "bonus": 4.1,
        "yc": 6.8,
        "pts": 80.0,
        "value": 20.0,
        "matched": true,
        "matchName": "Mendy"
      },
      {
        "playerId": 41,
        "name": "Emiliano Buend\u00eda",
        "webName": "Buend\u00eda",
        "position": "MID",
        "fplTeam": "AVL",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2395.0,
        "goals": 6.7,
        "assists": 5.2,
        "cleanSheets": 6.8,
        "bonus": 12.4,
        "yc": 5.1,
        "pts": 130.1,
        "value": 21.7,
        "matched": true,
        "matchName": "Buendia"
      },
      {
        "playerId": 384,
        "name": "Gianluigi Donnarumma",
        "webName": "Donnarumma",
        "position": "GK",
        "fplTeam": "MCI",
        "fplPos": "GK",
        "fplPrice": 5.5,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.2,
        "cleanSheets": 12.1,
        "bonus": 6.1,
        "yc": 5.1,
        "pts": 127.1,
        "value": 23.1,
        "matched": true,
        "matchName": "Donnarumma"
      },
      {
        "playerId": 60,
        "name": "James Hill",
        "webName": "Hill",
        "position": "DEF",
        "fplTeam": "BOU",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 3127.0,
        "goals": 0.9,
        "assists": 3.1,
        "cleanSheets": 7.2,
        "bonus": 6.5,
        "yc": 7.9,
        "pts": 130.7,
        "value": 23.8,
        "matched": true,
        "matchName": "Hill"
      }
    ]
  },
  {
    "clubId": "2",
    "clubName": "WSFC",
    "managerName": "Chris Brown",
    "totalPts": 1386.7,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 67,
        "name": "Rayan Vitor Rayan",
        "webName": "Rayan",
        "position": "MID",
        "fplTeam": "BOU",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 2475.0,
        "goals": 7.7,
        "assists": 5.8,
        "cleanSheets": 5.7,
        "bonus": 8.7,
        "yc": 5.2,
        "pts": 131.7,
        "value": 20.3,
        "matched": true,
        "matchName": "Rayan"
      },
      {
        "playerId": 79,
        "name": "Francisco Evanilson Evanilson",
        "webName": "Evanilson",
        "position": "FWD",
        "fplTeam": "BOU",
        "fplPos": "FWD",
        "fplPrice": 6.0,
        "mins": 2670.0,
        "goals": 9.4,
        "assists": 3.9,
        "cleanSheets": 0.0,
        "bonus": 12.5,
        "yc": 3.4,
        "pts": 124.3,
        "value": 20.7,
        "matched": true,
        "matchName": "Evanilson"
      },
      {
        "playerId": 94,
        "name": "Kevin Schade",
        "webName": "Schade",
        "position": "MID",
        "fplTeam": "BRE",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2580.0,
        "goals": 8.2,
        "assists": 4.0,
        "cleanSheets": 6.1,
        "bonus": 9.1,
        "yc": 5.4,
        "pts": 128.3,
        "value": 21.4,
        "matched": true,
        "matchName": "Schade"
      },
      {
        "playerId": 6,
        "name": "William Saliba",
        "webName": "Saliba",
        "position": "DEF",
        "fplTeam": "ARS",
        "fplPos": "DEF",
        "fplPrice": 6.0,
        "mins": 2376.0,
        "goals": 1.5,
        "assists": 1.1,
        "cleanSheets": 10.9,
        "bonus": 10.0,
        "yc": 2.4,
        "pts": 121.9,
        "value": 20.3,
        "matched": true,
        "matchName": "Saliba"
      },
      {
        "playerId": 260,
        "name": "Harry Wilson",
        "webName": "Wilson",
        "position": "MID",
        "fplTeam": "LEE",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 2665.0,
        "goals": 8.3,
        "assists": 7.2,
        "cleanSheets": 6.6,
        "bonus": 15.0,
        "yc": 6.6,
        "pts": 146.2,
        "value": 22.5,
        "matched": true,
        "matchName": "Wilson"
      },
      {
        "playerId": 467,
        "name": "Matz Sels",
        "webName": "Sels",
        "position": "GK",
        "fplTeam": "NFO",
        "fplPos": "GK",
        "fplPrice": 5.0,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.4,
        "cleanSheets": 7.7,
        "bonus": 7.2,
        "yc": 3.4,
        "pts": 117.4,
        "value": 23.5,
        "matched": true,
        "matchName": "Sels"
      },
      {
        "playerId": 152,
        "name": "Marco Palestra",
        "webName": "Palestra",
        "position": "DEF",
        "fplTeam": "CHE",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2850.0,
        "goals": 2.7,
        "assists": 5.2,
        "cleanSheets": 9.4,
        "bonus": 9.8,
        "yc": 6.7,
        "pts": 134.7,
        "value": 24.5,
        "matched": true,
        "matchName": "Palestra"
      },
      {
        "playerId": 471,
        "name": "Nikola Milenkovi\u0107",
        "webName": "Milenkovi\u0107",
        "position": "DEF",
        "fplTeam": "NFO",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 3129.0,
        "goals": 2.1,
        "assists": 1.5,
        "cleanSheets": 7.6,
        "bonus": 4.4,
        "yc": 6.1,
        "pts": 116.8,
        "value": 21.2,
        "matched": true,
        "matchName": "Milenkovic"
      },
      {
        "playerId": 449,
        "name": "Lewis Hall",
        "webName": "Hall",
        "position": "DEF",
        "fplTeam": "NEW",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 2465.0,
        "goals": 0.9,
        "assists": 4.7,
        "cleanSheets": 5.6,
        "bonus": 7.3,
        "yc": 5.4,
        "pts": 97.4,
        "value": 19.5,
        "matched": true,
        "matchName": "Hall"
      },
      {
        "playerId": 372,
        "name": "Alexis Mac Allister",
        "webName": "Mac Allister",
        "position": "MID",
        "fplTeam": "LIV",
        "fplPos": "MID",
        "fplPrice": 5.5,
        "mins": 2777.0,
        "goals": 4.2,
        "assists": 5.8,
        "cleanSheets": 9.5,
        "bonus": 8.9,
        "yc": 7.2,
        "pts": 125.2,
        "value": 22.8,
        "matched": true,
        "matchName": "Mac Allister"
      },
      {
        "playerId": 397,
        "name": "Antoine Semenyo",
        "webName": "Semenyo",
        "position": "MID",
        "fplTeam": "MCI",
        "fplPos": "MID",
        "fplPrice": 8.5,
        "mins": 2536.0,
        "goals": 9.1,
        "assists": 5.1,
        "cleanSheets": 9.6,
        "bonus": 12.0,
        "yc": 5.3,
        "pts": 142.8,
        "value": 16.8,
        "matched": true,
        "matchName": "Semenyo"
      }
    ]
  },
  {
    "clubId": "8",
    "clubName": "Ozlympiacoz",
    "managerName": "David Osborne",
    "totalPts": 1385.8,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 426,
        "name": "Bruno B.Fernandes",
        "webName": "B.Fernandes",
        "position": "MID",
        "fplTeam": "MUN",
        "fplPos": "MID",
        "fplPrice": 12.0,
        "mins": 3039.0,
        "goals": 11.0,
        "assists": 15.2,
        "cleanSheets": 10.3,
        "bonus": 27.7,
        "yc": 6.1,
        "pts": 208.9,
        "value": 17.4,
        "matched": true,
        "matchName": "B.Fernandes"
      },
      {
        "playerId": 472,
        "name": "Murillo Murillo",
        "webName": "Murillo",
        "position": "DEF",
        "fplTeam": "NFO",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 3081.0,
        "goals": 1.7,
        "assists": 1.4,
        "cleanSheets": 7.5,
        "bonus": 9.0,
        "yc": 7.2,
        "pts": 123.2,
        "value": 22.4,
        "matched": true,
        "matchName": "Murillo"
      },
      {
        "playerId": 532,
        "name": "Daniel Ballard",
        "webName": "Ballard",
        "position": "DEF",
        "fplTeam": "SUN",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 2825.0,
        "goals": 2.9,
        "assists": 1.6,
        "cleanSheets": 6.3,
        "bonus": 9.2,
        "yc": 6.6,
        "pts": 124.7,
        "value": 24.9,
        "matched": true,
        "matchName": "Ballard"
      },
      {
        "playerId": 209,
        "name": "Brennan Johnson",
        "webName": "Johnson",
        "position": "MID",
        "fplTeam": "EVE",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 558.0,
        "goals": 1.5,
        "assists": 1.1,
        "cleanSheets": 1.4,
        "bonus": 1.6,
        "yc": 1.4,
        "pts": 30.8,
        "value": 5.1,
        "matched": true,
        "matchName": "Johnson"
      },
      {
        "playerId": 68,
        "name": "Marcus Tavernier",
        "webName": "Tavernier",
        "position": "MID",
        "fplTeam": "BOU",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2475.0,
        "goals": 6.0,
        "assists": 6.1,
        "cleanSheets": 5.7,
        "bonus": 10.9,
        "yc": 5.6,
        "pts": 128.7,
        "value": 21.5,
        "matched": true,
        "matchName": "Tavernier"
      },
      {
        "playerId": 371,
        "name": "Ryan Gravenberch",
        "webName": "Gravenberch",
        "position": "MID",
        "fplTeam": "LIV",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2855.0,
        "goals": 2.7,
        "assists": 4.5,
        "cleanSheets": 9.8,
        "bonus": 8.7,
        "yc": 5.5,
        "pts": 119.1,
        "value": 19.8,
        "matched": true,
        "matchName": "Gravenberch"
      },
      {
        "playerId": 1,
        "name": "David Raya",
        "webName": "Raya",
        "position": "GK",
        "fplTeam": "ARS",
        "fplPos": "GK",
        "fplPrice": 6.0,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.1,
        "cleanSheets": 14.5,
        "bonus": 11.1,
        "yc": 1.6,
        "pts": 143.0,
        "value": 23.8,
        "matched": true,
        "matchName": "Raya"
      },
      {
        "playerId": 346,
        "name": "Dominic Calvert-Lewin",
        "webName": "Calvert-Lewin",
        "position": "FWD",
        "fplTeam": "LEE",
        "fplPos": "FWD",
        "fplPrice": 6.0,
        "mins": 2843.0,
        "goals": 12.4,
        "assists": 2.8,
        "cleanSheets": 0.0,
        "bonus": 15.1,
        "yc": 4.8,
        "pts": 136.1,
        "value": 22.7,
        "matched": true,
        "matchName": "Calvert-Lewin"
      },
      {
        "playerId": 43,
        "name": "Youri Tielemans",
        "webName": "Tielemans",
        "position": "MID",
        "fplTeam": "MUN",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2786.0,
        "goals": 2.7,
        "assists": 6.6,
        "cleanSheets": 9.5,
        "bonus": 8.0,
        "yc": 4.2,
        "pts": 130.0,
        "value": 21.7,
        "matched": true,
        "matchName": "Tielemans"
      },
      {
        "playerId": 581,
        "name": "Ousmane Diomande",
        "webName": "Diomande",
        "position": "DEF",
        "fplTeam": "NFO",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2708.0,
        "goals": 2.1,
        "assists": 1.9,
        "cleanSheets": 6.6,
        "bonus": 6.9,
        "yc": 5.9,
        "pts": 108.6,
        "value": 19.7,
        "matched": true,
        "matchName": "Diomande"
      },
      {
        "playerId": 499,
        "name": "Pedro Pedro Porro",
        "webName": "Pedro Porro",
        "position": "DEF",
        "fplTeam": "TOT",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2744.0,
        "goals": 2.2,
        "assists": 6.6,
        "cleanSheets": 8.0,
        "bonus": 11.0,
        "yc": 6.4,
        "pts": 132.7,
        "value": 24.1,
        "matched": true,
        "matchName": "Pedro Porro"
      }
    ]
  },
  {
    "clubId": "6",
    "clubName": "Rick Wallers Athletic?",
    "managerName": "Steve Whiteside",
    "totalPts": 1360.6,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 154,
        "name": "Cole Palmer",
        "webName": "Palmer",
        "position": "MID",
        "fplTeam": "CHE",
        "fplPos": "MID",
        "fplPrice": 9.5,
        "mins": 2873.0,
        "goals": 16.1,
        "assists": 10.1,
        "cleanSheets": 9.5,
        "bonus": 23.1,
        "yc": 6.1,
        "pts": 207.1,
        "value": 21.8,
        "matched": true,
        "matchName": "Palmer"
      },
      {
        "playerId": 453,
        "name": "Harvey Barnes",
        "webName": "Barnes",
        "position": "MID",
        "fplTeam": "NEW",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 1821.0,
        "goals": 6.2,
        "assists": 4.1,
        "cleanSheets": 4.1,
        "bonus": 6.8,
        "yc": 1.9,
        "pts": 102.8,
        "value": 17.1,
        "matched": true,
        "matchName": "Barnes"
      },
      {
        "playerId": 427,
        "name": "Bryan Mbeumo",
        "webName": "Mbeumo",
        "position": "MID",
        "fplTeam": "MUN",
        "fplPos": "MID",
        "fplPrice": 8.0,
        "mins": 2839.0,
        "goals": 13.3,
        "assists": 8.4,
        "cleanSheets": 9.6,
        "bonus": 15.8,
        "yc": 4.0,
        "pts": 182.4,
        "value": 22.8,
        "matched": true,
        "matchName": "Mbeumo"
      },
      {
        "playerId": 423,
        "name": "Luke Shaw",
        "webName": "Shaw",
        "position": "DEF",
        "fplTeam": "MUN",
        "fplPos": "DEF",
        "fplPrice": 4.5,
        "mins": 2839.0,
        "goals": 0.9,
        "assists": 3.2,
        "cleanSheets": 9.6,
        "bonus": 5.0,
        "yc": 8.5,
        "pts": 113.6,
        "value": 25.2,
        "matched": true,
        "matchName": "Shaw"
      },
      {
        "playerId": 366,
        "name": "Florian Wirtz",
        "webName": "Wirtz",
        "position": "MID",
        "fplTeam": "LIV",
        "fplPos": "MID",
        "fplPrice": 7.5,
        "mins": 2804.0,
        "goals": 7.4,
        "assists": 8.3,
        "cleanSheets": 9.6,
        "bonus": 16.9,
        "yc": 3.2,
        "pts": 155.1,
        "value": 20.7,
        "matched": true,
        "matchName": "Wirtz"
      },
      {
        "playerId": 226,
        "name": "Jordan Pickford",
        "webName": "Pickford",
        "position": "GK",
        "fplTeam": "EVE",
        "fplPos": "GK",
        "fplPrice": 5.5,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.5,
        "cleanSheets": 8.1,
        "bonus": 12.6,
        "yc": 4.3,
        "pts": 123.4,
        "value": 22.4,
        "matched": true,
        "matchName": "Pickford"
      },
      {
        "playerId": 249,
        "name": "Thierno Barry",
        "webName": "Barry",
        "position": "FWD",
        "fplTeam": "EVE",
        "fplPos": "FWD",
        "fplPrice": 5.5,
        "mins": 1718.0,
        "goals": 6.7,
        "assists": 0.8,
        "cleanSheets": 0.0,
        "bonus": 7.4,
        "yc": 3.2,
        "pts": 81.6,
        "value": 14.8,
        "matched": true,
        "matchName": "Barry"
      },
      {
        "playerId": 391,
        "name": "Jo\u0161ko Gvardiol",
        "webName": "Gvardiol",
        "position": "DEF",
        "fplTeam": "MCI",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2841.0,
        "goals": 3.5,
        "assists": 3.2,
        "cleanSheets": 10.8,
        "bonus": 10.3,
        "yc": 3.7,
        "pts": 142.5,
        "value": 25.9,
        "matched": true,
        "matchName": "Gvardiol"
      },
      {
        "playerId": 61,
        "name": "Adrien Truffert",
        "webName": "Truffert",
        "position": "DEF",
        "fplTeam": "BOU",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 3127.0,
        "goals": 1.3,
        "assists": 4.9,
        "cleanSheets": 7.2,
        "bonus": 17.7,
        "yc": 6.7,
        "pts": 133.4,
        "value": 24.2,
        "matched": true,
        "matchName": "Truffert"
      },
      {
        "playerId": 157,
        "name": "Est\u00eav\u00e3o Est\u00eav\u00e3o",
        "webName": "Est\u00eav\u00e3o",
        "position": "MID",
        "fplTeam": "CHE",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 635.0,
        "goals": 1.9,
        "assists": 2.5,
        "cleanSheets": 2.1,
        "bonus": 2.0,
        "yc": 1.2,
        "pts": 41.0,
        "value": 6.3,
        "matched": true,
        "matchName": "Est\u00eavao"
      },
      {
        "playerId": 498,
        "name": "Marcos Senesi",
        "webName": "Senesi",
        "position": "DEF",
        "fplTeam": "TOT",
        "fplPos": "DEF",
        "fplPrice": 6.0,
        "mins": 1515.0,
        "goals": 0.8,
        "assists": 2.4,
        "cleanSheets": 4.5,
        "bonus": 6.4,
        "yc": 4.8,
        "pts": 77.7,
        "value": 12.9,
        "matched": true,
        "matchName": "Senesi"
      }
    ]
  },
  {
    "clubId": "11",
    "clubName": "Chairmans United",
    "managerName": "Dan Gwynne",
    "totalPts": 1317.9,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 356,
        "name": "Virgil Virgil",
        "webName": "Virgil",
        "position": "DEF",
        "fplTeam": "LIV",
        "fplPos": "DEF",
        "fplPrice": 6.5,
        "mins": 3130.0,
        "goals": 3.7,
        "assists": 1.8,
        "cleanSheets": 10.7,
        "bonus": 8.4,
        "yc": 4.2,
        "pts": 154.9,
        "value": 23.8,
        "matched": true,
        "matchName": "Virgil"
      },
      {
        "playerId": 469,
        "name": "Neco N.Williams",
        "webName": "N.Williams",
        "position": "DEF",
        "fplTeam": "NFO",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 3091.0,
        "goals": 2.0,
        "assists": 5.1,
        "cleanSheets": 7.5,
        "bonus": 11.2,
        "yc": 8.3,
        "pts": 123.6,
        "value": 24.7,
        "matched": true,
        "matchName": "N.Williams"
      },
      {
        "playerId": 542,
        "name": "Enzo E.Le F\u00e9e",
        "webName": "E.Le F\u00e9e",
        "position": "MID",
        "fplTeam": "SUN",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2825.0,
        "goals": 5.7,
        "assists": 7.1,
        "cleanSheets": 6.3,
        "bonus": 12.9,
        "yc": 5.9,
        "pts": 141.6,
        "value": 23.6,
        "matched": true,
        "matchName": "E.Le Fee"
      },
      {
        "playerId": 155,
        "name": "Enzo Enzo",
        "webName": "Enzo",
        "position": "MID",
        "fplTeam": "CHE",
        "fplPos": "MID",
        "fplPrice": 7.0,
        "mins": 2798.0,
        "goals": 7.3,
        "assists": 8.4,
        "cleanSheets": 9.2,
        "bonus": 12.3,
        "yc": 7.6,
        "pts": 152.0,
        "value": 21.7,
        "matched": true,
        "matchName": "Enzo"
      },
      {
        "playerId": 338,
        "name": "Ethan Ampadu",
        "webName": "Ampadu",
        "position": "MID",
        "fplTeam": "LEE",
        "fplPos": "MID",
        "fplPrice": 5.5,
        "mins": 2843.0,
        "goals": 1.7,
        "assists": 3.7,
        "cleanSheets": 7.1,
        "bonus": 9.0,
        "yc": 9.0,
        "pts": 118.5,
        "value": 21.6,
        "matched": true,
        "matchName": "Ampadu"
      },
      {
        "playerId": 552,
        "name": "Brian Brobbey",
        "webName": "Brobbey",
        "position": "FWD",
        "fplTeam": "SUN",
        "fplPos": "FWD",
        "fplPrice": 6.0,
        "mins": 2639.0,
        "goals": 10.2,
        "assists": 2.1,
        "cleanSheets": 0.0,
        "bonus": 14.1,
        "yc": 6.5,
        "pts": 120.3,
        "value": 20.0,
        "matched": true,
        "matchName": "Brobbey"
      },
      {
        "playerId": 368,
        "name": "Dominik Szoboszlai",
        "webName": "Szoboszlai",
        "position": "MID",
        "fplTeam": "LIV",
        "fplPos": "MID",
        "fplPrice": 7.0,
        "mins": 3030.0,
        "goals": 6.2,
        "assists": 9.9,
        "cleanSheets": 10.4,
        "bonus": 15.2,
        "yc": 6.3,
        "pts": 153.7,
        "value": 22.0,
        "matched": true,
        "matchName": "Szoboszlai"
      },
      {
        "playerId": 11,
        "name": "Cristhian Mosquera",
        "webName": "Mosquera",
        "position": "DEF",
        "fplTeam": "ARS",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 1330.0,
        "goals": 0.4,
        "assists": 0.8,
        "cleanSheets": 6.0,
        "bonus": 2.4,
        "yc": 2.2,
        "pts": 70.3,
        "value": 12.8,
        "matched": true,
        "matchName": "Mosquera"
      },
      {
        "playerId": 201,
        "name": "Daniel Mu\u00f1oz",
        "webName": "Mu\u00f1oz",
        "position": "DEF",
        "fplTeam": "CRY",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 1704.0,
        "goals": 2.2,
        "assists": 3.1,
        "cleanSheets": 3.7,
        "bonus": 5.4,
        "yc": 5.4,
        "pts": 81.8,
        "value": 14.9,
        "matched": true,
        "matchName": "Munoz"
      },
      {
        "playerId": 13,
        "name": "Declan Rice",
        "webName": "Rice",
        "position": "MID",
        "fplTeam": "ARS",
        "fplPos": "MID",
        "fplPrice": 7.5,
        "mins": 2585.0,
        "goals": 3.9,
        "assists": 6.6,
        "cleanSheets": 11.8,
        "bonus": 14.4,
        "yc": 3.9,
        "pts": 138.8,
        "value": 18.5,
        "matched": true,
        "matchName": "Rice"
      },
      {
        "playerId": 28,
        "name": "Emiliano Martinez",
        "webName": "Martinez",
        "position": "GK",
        "fplTeam": "AVL",
        "fplPos": "GK",
        "fplPrice": 5.0,
        "mins": 1571.0,
        "goals": 0.0,
        "assists": 0.1,
        "cleanSheets": 4.5,
        "bonus": 6.5,
        "yc": 2.0,
        "pts": 62.4,
        "value": 12.5,
        "matched": true,
        "matchName": "Martinez"
      }
    ]
  },
  {
    "clubId": "9",
    "clubName": "Rockys Rovers",
    "managerName": "James Barber",
    "totalPts": 1221.3,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 525,
        "name": "Mateus Fernandes",
        "webName": "Fernandes",
        "position": "MID",
        "fplTeam": "TOT",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2909.0,
        "goals": 3.3,
        "assists": 5.2,
        "cleanSheets": 8.5,
        "bonus": 8.9,
        "yc": 8.1,
        "pts": 137.3,
        "value": 22.9,
        "matched": true,
        "matchName": "Fernandes"
      },
      {
        "playerId": 533,
        "name": "Nordi Mukiele",
        "webName": "Mukiele",
        "position": "DEF",
        "fplTeam": "SUN",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2768.0,
        "goals": 2.8,
        "assists": 4.1,
        "cleanSheets": 6.2,
        "bonus": 9.5,
        "yc": 6.4,
        "pts": 126.7,
        "value": 23.0,
        "matched": true,
        "matchName": "Mukiele"
      },
      {
        "playerId": 432,
        "name": "Kobbie Mainoo",
        "webName": "Mainoo",
        "position": "MID",
        "fplTeam": "MUN",
        "fplPos": "MID",
        "fplPrice": 5.5,
        "mins": 1118.0,
        "goals": 0.7,
        "assists": 1.3,
        "cleanSheets": 3.8,
        "bonus": 1.5,
        "yc": 2.4,
        "pts": 47.5,
        "value": 8.6,
        "matched": true,
        "matchName": "Mainoo"
      },
      {
        "playerId": 445,
        "name": "Malick Thiaw",
        "webName": "Thiaw",
        "position": "DEF",
        "fplTeam": "NEW",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 3023.0,
        "goals": 3.5,
        "assists": 1.1,
        "cleanSheets": 6.9,
        "bonus": 10.6,
        "yc": 6.0,
        "pts": 126.5,
        "value": 25.3,
        "matched": true,
        "matchName": "Thiaw"
      },
      {
        "playerId": 480,
        "name": "Morgan Gibbs-White",
        "webName": "Gibbs-White",
        "position": "MID",
        "fplTeam": "NFO",
        "fplPos": "MID",
        "fplPrice": 8.0,
        "mins": 3014.0,
        "goals": 11.5,
        "assists": 8.9,
        "cleanSheets": 7.3,
        "bonus": 16.7,
        "yc": 7.1,
        "pts": 172.1,
        "value": 21.5,
        "matched": true,
        "matchName": "Gibbs-White"
      },
      {
        "playerId": 531,
        "name": "Melker Ellborg",
        "webName": "Ellborg",
        "position": "GK",
        "fplTeam": "SUN",
        "fplPos": "GK",
        "fplPrice": 4.5,
        "mins": 138.0,
        "goals": 0.0,
        "assists": 0.0,
        "cleanSheets": 0.3,
        "bonus": 0.3,
        "yc": 0.2,
        "pts": 5.0,
        "value": 1.1,
        "matched": true,
        "matchName": "Ellborg"
      },
      {
        "playerId": 565,
        "name": "Mamadou M.Sangar\u00e9",
        "webName": "M.Sangar\u00e9",
        "position": "MID",
        "fplTeam": "BRE",
        "fplPos": "MID",
        "fplPrice": 5.5,
        "mins": 2870.0,
        "goals": 2.9,
        "assists": 4.7,
        "cleanSheets": 6.7,
        "bonus": 6.6,
        "yc": 7.7,
        "pts": 129.4,
        "value": 23.5,
        "matched": true,
        "matchName": "M.Sangare"
      },
      {
        "playerId": 230,
        "name": "Jarrad Branthwaite",
        "webName": "Branthwaite",
        "position": "DEF",
        "fplTeam": "EVE",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2950.0,
        "goals": 1.8,
        "assists": 1.6,
        "cleanSheets": 7.5,
        "bonus": 5.6,
        "yc": 6.6,
        "pts": 122.5,
        "value": 22.3,
        "matched": true,
        "matchName": "Branthwaite"
      },
      {
        "playerId": 428,
        "name": "Matheus Cunha",
        "webName": "Cunha",
        "position": "MID",
        "fplTeam": "MUN",
        "fplPos": "MID",
        "fplPrice": 8.0,
        "mins": 2430.0,
        "goals": 10.7,
        "assists": 5.4,
        "cleanSheets": 8.3,
        "bonus": 17.0,
        "yc": 4.7,
        "pts": 155.8,
        "value": 19.5,
        "matched": true,
        "matchName": "Cunha"
      },
      {
        "playerId": 5,
        "name": "Jurri\u00ebn J.Timber",
        "webName": "J.Timber",
        "position": "DEF",
        "fplTeam": "ARS",
        "fplPos": "DEF",
        "fplPrice": 6.5,
        "mins": 2246.0,
        "goals": 2.8,
        "assists": 3.2,
        "cleanSheets": 10.3,
        "bonus": 7.9,
        "yc": 4.4,
        "pts": 124.4,
        "value": 19.1,
        "matched": true,
        "matchName": "J.Timber"
      },
      {
        "playerId": 439,
        "name": "Benjamin \u0160e\u0161ko",
        "webName": "\u0160e\u0161ko",
        "position": "FWD",
        "fplTeam": "MUN",
        "fplPos": "FWD",
        "fplPrice": 7.0,
        "mins": 1153.0,
        "goals": 7.2,
        "assists": 1.0,
        "cleanSheets": 0.0,
        "bonus": 8.7,
        "yc": 1.7,
        "pts": 74.1,
        "value": 10.6,
        "matched": true,
        "matchName": "\u0160esko"
      }
    ]
  },
  {
    "clubId": "1",
    "clubName": "Galatasaphilly",
    "managerName": "Phil Batten",
    "totalPts": 1209.7,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 25,
        "name": "Viktor Gy\u00f6keres",
        "webName": "Gy\u00f6keres",
        "position": "FWD",
        "fplTeam": "ARS",
        "fplPos": "FWD",
        "fplPrice": 7.5,
        "mins": 1114.0,
        "goals": 7.4,
        "assists": 1.3,
        "cleanSheets": 0.0,
        "bonus": 7.1,
        "yc": 1.6,
        "pts": 73.2,
        "value": 9.8,
        "matched": true,
        "matchName": "Gyokeres"
      },
      {
        "playerId": 123,
        "name": "Jack Hinshelwood",
        "webName": "Hinshelwood",
        "position": "MID",
        "fplTeam": "BRI",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2826.0,
        "goals": 7.4,
        "assists": 4.6,
        "cleanSheets": 7.3,
        "bonus": 9.1,
        "yc": 4.8,
        "pts": 130.3,
        "value": 21.7,
        "matched": true,
        "matchName": "Hinshelwood"
      },
      {
        "playerId": 419,
        "name": "Lisandro Martinez",
        "webName": "Martinez",
        "position": "DEF",
        "fplTeam": "MUN",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 2786.0,
        "goals": 1.4,
        "assists": 1.8,
        "cleanSheets": 9.5,
        "bonus": 6.0,
        "yc": 6.3,
        "pts": 122.6,
        "value": 24.5,
        "matched": true,
        "matchName": "Martinez"
      },
      {
        "playerId": 45,
        "name": "John McGinn",
        "webName": "McGinn",
        "position": "MID",
        "fplTeam": "AVL",
        "fplPos": "MID",
        "fplPrice": 5.5,
        "mins": 2776.0,
        "goals": 4.7,
        "assists": 6.6,
        "cleanSheets": 7.9,
        "bonus": 7.5,
        "yc": 7.6,
        "pts": 119.4,
        "value": 21.7,
        "matched": true,
        "matchName": "McGinn"
      },
      {
        "playerId": 198,
        "name": "Dean Henderson",
        "webName": "Henderson",
        "position": "GK",
        "fplTeam": "CRY",
        "fplPos": "GK",
        "fplPrice": 5.0,
        "mins": 3146.0,
        "goals": 0.0,
        "assists": 0.1,
        "cleanSheets": 6.9,
        "bonus": 9.5,
        "yc": 4.3,
        "pts": 114.3,
        "value": 22.9,
        "matched": true,
        "matchName": "Henderson"
      },
      {
        "playerId": 450,
        "name": "Tino Livramento",
        "webName": "Livramento",
        "position": "DEF",
        "fplTeam": "NEW",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 2225.0,
        "goals": 0.4,
        "assists": 2.4,
        "cleanSheets": 5.1,
        "bonus": 5.0,
        "yc": 3.0,
        "pts": 78.8,
        "value": 15.8,
        "matched": true,
        "matchName": "Livramento"
      },
      {
        "playerId": 551,
        "name": "Nilson Angulo",
        "webName": "Angulo",
        "position": "MID",
        "fplTeam": "SUN",
        "fplPos": "MID",
        "fplPrice": 5.0,
        "mins": 2331.0,
        "goals": 4.0,
        "assists": 4.1,
        "cleanSheets": 5.2,
        "bonus": 4.4,
        "yc": 4.2,
        "pts": 101.2,
        "value": 20.2,
        "matched": true,
        "matchName": "Angulo"
      },
      {
        "playerId": 165,
        "name": "Jo\u00e3o Pedro Jo\u00e3o Pedro",
        "webName": "Jo\u00e3o Pedro",
        "position": "FWD",
        "fplTeam": "CHE",
        "fplPos": "FWD",
        "fplPrice": 7.5,
        "mins": 2673.0,
        "goals": 14.5,
        "assists": 5.9,
        "cleanSheets": 0.0,
        "bonus": 23.1,
        "yc": 4.2,
        "pts": 160.9,
        "value": 21.5,
        "matched": true,
        "matchName": "Joao Pedro"
      },
      {
        "playerId": 400,
        "name": "J\u00e9r\u00e9my Doku",
        "webName": "Doku",
        "position": "MID",
        "fplTeam": "MCI",
        "fplPos": "MID",
        "fplPrice": 7.5,
        "mins": 2190.0,
        "goals": 4.3,
        "assists": 10.1,
        "cleanSheets": 8.3,
        "bonus": 11.8,
        "yc": 2.3,
        "pts": 127.9,
        "value": 17.1,
        "matched": true,
        "matchName": "Doku"
      },
      {
        "playerId": 388,
        "name": "Marc Gu\u00e9hi",
        "webName": "Gu\u00e9hi",
        "position": "DEF",
        "fplTeam": "MCI",
        "fplPos": "DEF",
        "fplPrice": 6.0,
        "mins": 1576.0,
        "goals": 1.1,
        "assists": 1.5,
        "cleanSheets": 6.0,
        "bonus": 4.2,
        "yc": 3.0,
        "pts": 80.6,
        "value": 13.4,
        "matched": true,
        "matchName": "Guehi"
      },
      {
        "playerId": 113,
        "name": "Ferdi F.Kad\u0131o\u011flu",
        "webName": "F.Kad\u0131o\u011flu",
        "position": "DEF",
        "fplTeam": "BRI",
        "fplPos": "DEF",
        "fplPrice": 4.5,
        "mins": 2696.0,
        "goals": 1.6,
        "assists": 2.9,
        "cleanSheets": 6.9,
        "bonus": 6.0,
        "yc": 6.2,
        "pts": 100.5,
        "value": 22.3,
        "matched": true,
        "matchName": "F.Kadioglu"
      }
    ]
  },
  {
    "clubId": "4",
    "clubName": "Bossman FC",
    "managerName": "Ed Bollingbroke",
    "totalPts": 1201.5,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 377,
        "name": "Victor Munoz",
        "webName": "Munoz",
        "position": "MID",
        "fplTeam": "LIV",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 676.0,
        "goals": 1.7,
        "assists": 2.2,
        "cleanSheets": 2.3,
        "bonus": 2.0,
        "yc": 0.9,
        "pts": 40.9,
        "value": 6.3,
        "matched": true,
        "matchName": "Munoz"
      },
      {
        "playerId": 70,
        "name": "Justin Kluivert",
        "webName": "Kluivert",
        "position": "MID",
        "fplTeam": "BOU",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2670.0,
        "goals": 9.3,
        "assists": 5.3,
        "cleanSheets": 6.2,
        "bonus": 10.0,
        "yc": 8.6,
        "pts": 137.6,
        "value": 22.9,
        "matched": true,
        "matchName": "Kluivert"
      },
      {
        "playerId": 399,
        "name": "Rayan Cherki",
        "webName": "Cherki",
        "position": "MID",
        "fplTeam": "MCI",
        "fplPos": "MID",
        "fplPrice": 7.5,
        "mins": 1410.0,
        "goals": 3.2,
        "assists": 8.7,
        "cleanSheets": 5.3,
        "bonus": 8.5,
        "yc": 1.8,
        "pts": 96.4,
        "value": 12.8,
        "matched": true,
        "matchName": "Cherki"
      },
      {
        "playerId": 358,
        "name": "Milos Kerkez",
        "webName": "Kerkez",
        "position": "DEF",
        "fplTeam": "LIV",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2731.0,
        "goals": 1.7,
        "assists": 2.9,
        "cleanSheets": 9.4,
        "bonus": 5.5,
        "yc": 4.9,
        "pts": 114.6,
        "value": 20.8,
        "matched": true,
        "matchName": "Kerkez"
      },
      {
        "playerId": 390,
        "name": "R\u00faben R\u00faben",
        "webName": "R\u00faben",
        "position": "DEF",
        "fplTeam": "MCI",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2714.0,
        "goals": 1.1,
        "assists": 1.4,
        "cleanSheets": 10.3,
        "bonus": 5.6,
        "yc": 3.8,
        "pts": 115.7,
        "value": 21.0,
        "matched": true,
        "matchName": "Ruben"
      },
      {
        "playerId": 529,
        "name": "Robin Roefs",
        "webName": "Roefs",
        "position": "GK",
        "fplTeam": "SUN",
        "fplPos": "GK",
        "fplPrice": 5.0,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.1,
        "cleanSheets": 7.1,
        "bonus": 10.4,
        "yc": 4.0,
        "pts": 118.0,
        "value": 23.6,
        "matched": true,
        "matchName": "Roefs"
      },
      {
        "playerId": 95,
        "name": "Dango O.Dango",
        "webName": "O.Dango",
        "position": "MID",
        "fplTeam": "BRE",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 2580.0,
        "goals": 6.8,
        "assists": 6.4,
        "cleanSheets": 6.1,
        "bonus": 14.6,
        "yc": 5.4,
        "pts": 138.4,
        "value": 21.3,
        "matched": true,
        "matchName": "O.Dango"
      },
      {
        "playerId": 411,
        "name": "Erling Haaland",
        "webName": "Haaland",
        "position": "FWD",
        "fplTeam": "MCI",
        "fplPos": "FWD",
        "fplPrice": 15.5,
        "mins": 3040.0,
        "goals": 25.4,
        "assists": 5.5,
        "cleanSheets": 0.0,
        "bonus": 34.6,
        "yc": 3.0,
        "pts": 220.2,
        "value": 14.2,
        "matched": true,
        "matchName": "Haaland"
      },
      {
        "playerId": 514,
        "name": "Mathys Tel",
        "webName": "Tel",
        "position": "MID",
        "fplTeam": "TOT",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 1125.0,
        "goals": 3.3,
        "assists": 2.7,
        "cleanSheets": 3.3,
        "bonus": 4.6,
        "yc": 2.0,
        "pts": 64.9,
        "value": 10.8,
        "matched": true,
        "matchName": "Tel"
      },
      {
        "playerId": 334,
        "name": "Tarik Muharemovi\u0107",
        "webName": "Muharemovi\u0107",
        "position": "DEF",
        "fplTeam": "LEE",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 3023.0,
        "goals": 2.0,
        "assists": 1.8,
        "cleanSheets": 7.5,
        "bonus": 7.1,
        "yc": 6.6,
        "pts": 120.8,
        "value": 24.2,
        "matched": true,
        "matchName": "Muharemovic"
      },
      {
        "playerId": 448,
        "name": "Dan Burn",
        "webName": "Burn",
        "position": "DEF",
        "fplTeam": "NEW",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 840.0,
        "goals": 0.4,
        "assists": 0.4,
        "cleanSheets": 1.9,
        "bonus": 1.5,
        "yc": 2.9,
        "pts": 34.0,
        "value": 6.8,
        "matched": true,
        "matchName": "Burn"
      }
    ]
  },
  {
    "clubId": "12",
    "clubName": "Wellenthia CF",
    "managerName": "Rich Hawkridge",
    "totalPts": 1189.2,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 69,
        "name": "Alex Scott",
        "webName": "Scott",
        "position": "MID",
        "fplTeam": "BOU",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2723.0,
        "goals": 2.9,
        "assists": 4.1,
        "cleanSheets": 6.3,
        "bonus": 8.4,
        "yc": 7.6,
        "pts": 129.5,
        "value": 21.6,
        "matched": true,
        "matchName": "Scott"
      },
      {
        "playerId": 515,
        "name": "James Maddison",
        "webName": "Maddison",
        "position": "MID",
        "fplTeam": "TOT",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 1151.0,
        "goals": 4.6,
        "assists": 4.6,
        "cleanSheets": 3.4,
        "bonus": 6.8,
        "yc": 2.8,
        "pts": 79.6,
        "value": 12.2,
        "matched": true,
        "matchName": "Maddison"
      },
      {
        "playerId": 142,
        "name": "Reece James",
        "webName": "James",
        "position": "DEF",
        "fplTeam": "CHE",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 806.0,
        "goals": 0.7,
        "assists": 2.1,
        "cleanSheets": 2.7,
        "bonus": 3.2,
        "yc": 1.6,
        "pts": 45.3,
        "value": 8.2,
        "matched": true,
        "matchName": "James"
      },
      {
        "playerId": 200,
        "name": "Maxence Lacroix",
        "webName": "Lacroix",
        "position": "DEF",
        "fplTeam": "CHE",
        "fplPos": "DEF",
        "fplPrice": 6.0,
        "mins": 2975.0,
        "goals": 1.6,
        "assists": 1.8,
        "cleanSheets": 9.8,
        "bonus": 8.8,
        "yc": 4.9,
        "pts": 136.5,
        "value": 22.7,
        "matched": true,
        "matchName": "Lacroix"
      },
      {
        "playerId": 503,
        "name": "Micky Van de Ven",
        "webName": "Van de Ven",
        "position": "DEF",
        "fplTeam": "TOT",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 2740.0,
        "goals": 3.2,
        "assists": 1.1,
        "cleanSheets": 8.0,
        "bonus": 9.9,
        "yc": 7.6,
        "pts": 117.9,
        "value": 23.6,
        "matched": true,
        "matchName": "Van de Ven"
      },
      {
        "playerId": 236,
        "name": "Kiernan Dewsbury-Hall",
        "webName": "Dewsbury-Hall",
        "position": "MID",
        "fplTeam": "EVE",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 2973.0,
        "goals": 6.2,
        "assists": 8.3,
        "cleanSheets": 7.5,
        "bonus": 15.1,
        "yc": 6.7,
        "pts": 148.1,
        "value": 22.8,
        "matched": true,
        "matchName": "Dewsbury-Hall"
      },
      {
        "playerId": 393,
        "name": "Abdukodir Khusanov",
        "webName": "Khusanov",
        "position": "DEF",
        "fplTeam": "MCI",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 1869.0,
        "goals": 0.6,
        "assists": 0.9,
        "cleanSheets": 7.1,
        "bonus": 3.4,
        "yc": 3.2,
        "pts": 81.7,
        "value": 14.9,
        "matched": true,
        "matchName": "Khusanov"
      },
      {
        "playerId": 238,
        "name": "Jack Grealish",
        "webName": "Grealish",
        "position": "MID",
        "fplTeam": "MCI",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 313.0,
        "goals": 0.5,
        "assists": 1.1,
        "cleanSheets": 1.2,
        "bonus": 1.2,
        "yc": 0.8,
        "pts": 18.2,
        "value": 2.8,
        "matched": true,
        "matchName": "Grealish"
      },
      {
        "playerId": 412,
        "name": "Senne Lammens",
        "webName": "Lammens",
        "position": "GK",
        "fplTeam": "MUN",
        "fplPos": "GK",
        "fplPrice": 5.0,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.1,
        "cleanSheets": 10.8,
        "bonus": 10.3,
        "yc": 1.5,
        "pts": 130.5,
        "value": 26.1,
        "matched": true,
        "matchName": "Lammens"
      },
      {
        "playerId": 379,
        "name": "Alexander Isak",
        "webName": "Isak",
        "position": "FWD",
        "fplTeam": "LIV",
        "fplPos": "FWD",
        "fplPrice": 9.0,
        "mins": 2855.0,
        "goals": 20.5,
        "assists": 5.0,
        "cleanSheets": 0.0,
        "bonus": 25.9,
        "yc": 2.7,
        "pts": 188.0,
        "value": 20.9,
        "matched": true,
        "matchName": "Isak"
      },
      {
        "playerId": 159,
        "name": "Mois\u00e9s Caicedo",
        "webName": "Caicedo",
        "position": "MID",
        "fplTeam": "CHE",
        "fplPos": "MID",
        "fplPrice": 5.5,
        "mins": 2996.0,
        "goals": 1.9,
        "assists": 3.4,
        "cleanSheets": 9.9,
        "bonus": 6.3,
        "yc": 9.9,
        "pts": 113.9,
        "value": 20.7,
        "matched": true,
        "matchName": "Caicedo"
      }
    ]
  },
  {
    "clubId": "3",
    "clubName": "FC Giraffe Boys",
    "managerName": "David Atkinson",
    "totalPts": 1185.7,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 237,
        "name": "Iliman Ndiaye",
        "webName": "Ndiaye",
        "position": "MID",
        "fplTeam": "EVE",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 2819.0,
        "goals": 7.1,
        "assists": 4.8,
        "cleanSheets": 7.1,
        "bonus": 10.8,
        "yc": 4.2,
        "pts": 139.7,
        "value": 23.3,
        "matched": true,
        "matchName": "Ndiaye"
      },
      {
        "playerId": 323,
        "name": "Kasey McAteer",
        "webName": "McAteer",
        "position": "MID",
        "fplTeam": "IPS",
        "fplPos": "MID",
        "fplPrice": 4.5,
        "mins": 262.0,
        "goals": 0.4,
        "assists": 0.4,
        "cleanSheets": 0.5,
        "bonus": 0.4,
        "yc": 0.5,
        "pts": 12.5,
        "value": 2.8,
        "matched": true,
        "matchName": "McAteer"
      },
      {
        "playerId": 122,
        "name": "Yankuba Minteh",
        "webName": "Minteh",
        "position": "MID",
        "fplTeam": "BRI",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 1894.0,
        "goals": 3.8,
        "assists": 5.3,
        "cleanSheets": 4.9,
        "bonus": 7.8,
        "yc": 3.8,
        "pts": 94.8,
        "value": 15.8,
        "matched": true,
        "matchName": "Minteh"
      },
      {
        "playerId": 202,
        "name": "Chris Richards",
        "webName": "Richards",
        "position": "DEF",
        "fplTeam": "CRY",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 2866.0,
        "goals": 1.6,
        "assists": 1.2,
        "cleanSheets": 6.3,
        "bonus": 5.6,
        "yc": 5.9,
        "pts": 113.0,
        "value": 22.6,
        "matched": true,
        "matchName": "Richards"
      },
      {
        "playerId": 387,
        "name": "Nico O'Reilly",
        "webName": "O'Reilly",
        "position": "DEF",
        "fplTeam": "MCI",
        "fplPos": "DEF",
        "fplPrice": 6.5,
        "mins": 2360.0,
        "goals": 4.0,
        "assists": 4.0,
        "cleanSheets": 8.9,
        "bonus": 8.4,
        "yc": 4.0,
        "pts": 131.9,
        "value": 20.3,
        "matched": true,
        "matchName": "O'Reilly"
      },
      {
        "playerId": 357,
        "name": "Jeremie Frimpong",
        "webName": "Frimpong",
        "position": "DEF",
        "fplTeam": "LIV",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2731.0,
        "goals": 1.3,
        "assists": 7.2,
        "cleanSheets": 9.4,
        "bonus": 5.7,
        "yc": 4.6,
        "pts": 123.2,
        "value": 22.4,
        "matched": true,
        "matchName": "Frimpong"
      },
      {
        "playerId": 401,
        "name": "Omar Marmoush",
        "webName": "Marmoush",
        "position": "FWD",
        "fplTeam": "MCI",
        "fplPos": "FWD",
        "fplPrice": 7.0,
        "mins": 922.0,
        "goals": 4.1,
        "assists": 2.1,
        "cleanSheets": 0.0,
        "bonus": 5.7,
        "yc": 1.4,
        "pts": 56.3,
        "value": 8.0,
        "matched": true,
        "matchName": "Marmoush"
      },
      {
        "playerId": 12,
        "name": "Bukayo Saka",
        "webName": "Saka",
        "position": "MID",
        "fplTeam": "ARS",
        "fplPos": "MID",
        "fplPrice": 9.5,
        "mins": 2955.0,
        "goals": 12.6,
        "assists": 13.7,
        "cleanSheets": 13.4,
        "bonus": 22.2,
        "yc": 3.6,
        "pts": 207.3,
        "value": 21.8,
        "matched": true,
        "matchName": "Saka"
      },
      {
        "playerId": 84,
        "name": "Nathan Collins",
        "webName": "Collins",
        "position": "DEF",
        "fplTeam": "BRE",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 2674.0,
        "goals": 1.2,
        "assists": 2.1,
        "cleanSheets": 6.3,
        "bonus": 7.2,
        "yc": 5.5,
        "pts": 110.6,
        "value": 20.1,
        "matched": true,
        "matchName": "Collins"
      },
      {
        "playerId": 369,
        "name": "Rio Ngumoha",
        "webName": "Ngumoha",
        "position": "MID",
        "fplTeam": "LIV",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 1113.0,
        "goals": 2.6,
        "assists": 3.9,
        "cleanSheets": 3.8,
        "bonus": 4.0,
        "yc": 1.3,
        "pts": 65.1,
        "value": 10.8,
        "matched": true,
        "matchName": "Ngumoha"
      },
      {
        "playerId": 350,
        "name": "Alisson A.Becker",
        "webName": "A.Becker",
        "position": "GK",
        "fplTeam": "LIV",
        "fplPos": "GK",
        "fplPrice": 5.5,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.2,
        "cleanSheets": 11.0,
        "bonus": 10.4,
        "yc": 1.3,
        "pts": 131.3,
        "value": 23.9,
        "matched": true,
        "matchName": "A.Becker"
      }
    ]
  },
  {
    "clubId": "5",
    "clubName": "Do the Math FC",
    "managerName": "Stu Berry",
    "totalPts": 1162.0,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 78,
        "name": "Junior Kroupi.Jr",
        "webName": "Kroupi.Jr",
        "position": "MID",
        "fplTeam": "BOU",
        "fplPos": "MID",
        "fplPrice": 7.5,
        "mins": 759.0,
        "goals": 4.2,
        "assists": 0.8,
        "cleanSheets": 1.6,
        "bonus": 5.0,
        "yc": 1.9,
        "pts": 51.4,
        "value": 6.9,
        "matched": true,
        "matchName": "Kroupi.Jr"
      },
      {
        "playerId": 106,
        "name": "Igor Thiago Thiago",
        "webName": "Thiago",
        "position": "FWD",
        "fplTeam": "BRE",
        "fplPos": "FWD",
        "fplPrice": 8.0,
        "mins": 3039.0,
        "goals": 17.2,
        "assists": 2.3,
        "cleanSheets": 0.0,
        "bonus": 22.6,
        "yc": 6.4,
        "pts": 164.4,
        "value": 20.6,
        "matched": true,
        "matchName": "Thiago"
      },
      {
        "playerId": 570,
        "name": "C\u00e9sar Palacios",
        "webName": "Palacios",
        "position": "MID",
        "fplTeam": "FUL",
        "fplPos": "MID",
        "fplPrice": 5.5,
        "mins": 1587.0,
        "goals": 2.9,
        "assists": 2.7,
        "cleanSheets": 3.7,
        "bonus": 4.9,
        "yc": 3.1,
        "pts": 73.7,
        "value": 13.4,
        "matched": true,
        "matchName": "Palacios"
      },
      {
        "playerId": 398,
        "name": "Phil Foden",
        "webName": "Foden",
        "position": "MID",
        "fplTeam": "MCI",
        "fplPos": "MID",
        "fplPrice": 7.0,
        "mins": 2012.0,
        "goals": 6.9,
        "assists": 6.8,
        "cleanSheets": 7.6,
        "bonus": 10.9,
        "yc": 2.3,
        "pts": 126.2,
        "value": 18.0,
        "matched": true,
        "matchName": "Foden"
      },
      {
        "playerId": 40,
        "name": "Morgan Rogers",
        "webName": "Rogers",
        "position": "MID",
        "fplTeam": "CHE",
        "fplPos": "MID",
        "fplPrice": 7.5,
        "mins": 2925.0,
        "goals": 8.4,
        "assists": 7.6,
        "cleanSheets": 9.7,
        "bonus": 14.0,
        "yc": 6.7,
        "pts": 153.4,
        "value": 20.5,
        "matched": true,
        "matchName": "Rogers"
      },
      {
        "playerId": 124,
        "name": "Pascal Gro\u00df",
        "webName": "Gro\u00df",
        "position": "MID",
        "fplTeam": "BRI",
        "fplPos": "MID",
        "fplPrice": 5.5,
        "mins": 2826.0,
        "goals": 3.9,
        "assists": 8.3,
        "cleanSheets": 7.3,
        "bonus": 16.9,
        "yc": 6.1,
        "pts": 134.7,
        "value": 24.5,
        "matched": true,
        "matchName": "Gro\u00df"
      },
      {
        "playerId": 535,
        "name": "Omar Alderete",
        "webName": "Alderete",
        "position": "DEF",
        "fplTeam": "SUN",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 2954.0,
        "goals": 1.5,
        "assists": 1.3,
        "cleanSheets": 6.6,
        "bonus": 5.2,
        "yc": 7.2,
        "pts": 112.5,
        "value": 22.5,
        "matched": true,
        "matchName": "Alderete"
      },
      {
        "playerId": 232,
        "name": "Jake O'Brien",
        "webName": "O'Brien",
        "position": "DEF",
        "fplTeam": "EVE",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 1379.0,
        "goals": 0.7,
        "assists": 0.9,
        "cleanSheets": 3.5,
        "bonus": 1.5,
        "yc": 3.5,
        "pts": 53.1,
        "value": 10.6,
        "matched": true,
        "matchName": "O'Brien"
      },
      {
        "playerId": 82,
        "name": "Caoimh\u00edn Kelleher",
        "webName": "Kelleher",
        "position": "GK",
        "fplTeam": "BRE",
        "fplPos": "GK",
        "fplPrice": 5.0,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.2,
        "cleanSheets": 7.5,
        "bonus": 11.6,
        "yc": 1.7,
        "pts": 122.1,
        "value": 24.4,
        "matched": true,
        "matchName": "Kelleher"
      },
      {
        "playerId": 392,
        "name": "Rayan A\u00eft-Nouri",
        "webName": "A\u00eft-Nouri",
        "position": "DEF",
        "fplTeam": "MCI",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 988.0,
        "goals": 0.7,
        "assists": 1.9,
        "cleanSheets": 3.7,
        "bonus": 3.3,
        "yc": 2.1,
        "pts": 53.6,
        "value": 9.8,
        "matched": true,
        "matchName": "A\u00eft-Nouri"
      },
      {
        "playerId": 253,
        "name": "Joachim Andersen",
        "webName": "Andersen",
        "position": "DEF",
        "fplTeam": "FUL",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 2971.0,
        "goals": 1.0,
        "assists": 1.9,
        "cleanSheets": 6.9,
        "bonus": 7.9,
        "yc": 8.2,
        "pts": 116.9,
        "value": 23.4,
        "matched": true,
        "matchName": "Andersen"
      }
    ]
  },
  {
    "clubId": "13",
    "clubName": "Ladyboy Loving Losers",
    "managerName": "Daff",
    "totalPts": 1133.4,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 9,
        "name": "Piero Hincapie",
        "webName": "Hincapie",
        "position": "DEF",
        "fplTeam": "ARS",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 557.0,
        "goals": 0.3,
        "assists": 0.6,
        "cleanSheets": 2.5,
        "bonus": 1.6,
        "yc": 0.7,
        "pts": 32.8,
        "value": 6.0,
        "matched": true,
        "matchName": "Hincapie"
      },
      {
        "playerId": 455,
        "name": "Sandro Tonali",
        "webName": "Tonali",
        "position": "MID",
        "fplTeam": "TOT",
        "fplPos": "MID",
        "fplPrice": 5.5,
        "mins": 2909.0,
        "goals": 2.8,
        "assists": 4.3,
        "cleanSheets": 8.5,
        "bonus": 6.6,
        "yc": 6.9,
        "pts": 121.3,
        "value": 22.1,
        "matched": true,
        "matchName": "Tonali"
      },
      {
        "playerId": 418,
        "name": "Harry Maguire",
        "webName": "Maguire",
        "position": "DEF",
        "fplTeam": "MUN",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 1722.0,
        "goals": 1.3,
        "assists": 1.0,
        "cleanSheets": 5.9,
        "bonus": 3.6,
        "yc": 4.4,
        "pts": 82.8,
        "value": 16.6,
        "matched": true,
        "matchName": "Maguire"
      },
      {
        "playerId": 140,
        "name": "Robert S\u00e1nchez",
        "webName": "S\u00e1nchez",
        "position": "GK",
        "fplTeam": "CHE",
        "fplPos": "GK",
        "fplPrice": 5.0,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.2,
        "cleanSheets": 10.5,
        "bonus": 9.0,
        "yc": 3.4,
        "pts": 127.3,
        "value": 25.5,
        "matched": true,
        "matchName": "Sanchez"
      },
      {
        "playerId": 55,
        "name": "Ollie Watkins",
        "webName": "Watkins",
        "position": "FWD",
        "fplTeam": "AVL",
        "fplPos": "FWD",
        "fplPrice": 8.0,
        "mins": 2238.0,
        "goals": 13.8,
        "assists": 4.1,
        "cleanSheets": 0.0,
        "bonus": 21.7,
        "yc": 3.5,
        "pts": 144.3,
        "value": 18.0,
        "matched": true,
        "matchName": "Watkins"
      },
      {
        "playerId": 491,
        "name": "Igor Jesus Igor Jesus",
        "webName": "Igor Jesus",
        "position": "FWD",
        "fplTeam": "NFO",
        "fplPos": "FWD",
        "fplPrice": 6.0,
        "mins": 2088.0,
        "goals": 7.4,
        "assists": 3.5,
        "cleanSheets": 0.0,
        "bonus": 11.3,
        "yc": 3.1,
        "pts": 103.7,
        "value": 17.3,
        "matched": true,
        "matchName": "Igor Jesus"
      },
      {
        "playerId": 4,
        "name": "Gabriel Gabriel",
        "webName": "Gabriel",
        "position": "DEF",
        "fplTeam": "ARS",
        "fplPos": "DEF",
        "fplPrice": 8.0,
        "mins": 3117.0,
        "goals": 4.2,
        "assists": 2.6,
        "cleanSheets": 14.2,
        "bonus": 19.5,
        "yc": 4.5,
        "pts": 186.7,
        "value": 23.3,
        "matched": true,
        "matchName": "Gabriel"
      },
      {
        "playerId": 156,
        "name": "Pedro Neto",
        "webName": "Neto",
        "position": "MID",
        "fplTeam": "CHE",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 2475.0,
        "goals": 4.7,
        "assists": 8.8,
        "cleanSheets": 8.2,
        "bonus": 8.0,
        "yc": 4.9,
        "pts": 124.5,
        "value": 19.2,
        "matched": true,
        "matchName": "Neto"
      },
      {
        "playerId": 367,
        "name": "Cody Gakpo",
        "webName": "Gakpo",
        "position": "MID",
        "fplTeam": "LIV",
        "fplPos": "MID",
        "fplPrice": 7.0,
        "mins": 2680.0,
        "goals": 10.0,
        "assists": 6.7,
        "cleanSheets": 9.2,
        "bonus": 12.8,
        "yc": 3.8,
        "pts": 153.6,
        "value": 21.9,
        "matched": true,
        "matchName": "Gakpo"
      },
      {
        "playerId": 429,
        "name": "Marcus Rashford",
        "webName": "Rashford",
        "position": "MID",
        "fplTeam": "MUN",
        "fplPos": "MID",
        "fplPrice": 7.0,
        "mins": 103.0,
        "goals": 0.4,
        "assists": 0.2,
        "cleanSheets": 0.4,
        "bonus": 0.3,
        "yc": 0.1,
        "pts": 7.2,
        "value": 1.0,
        "matched": true,
        "matchName": "Rashford"
      },
      {
        "playerId": 231,
        "name": "Michael Keane",
        "webName": "Keane",
        "position": "DEF",
        "fplTeam": "EVE",
        "fplPos": "DEF",
        "fplPrice": 5.0,
        "mins": 1015.0,
        "goals": 1.1,
        "assists": 0.4,
        "cleanSheets": 2.6,
        "bonus": 2.7,
        "yc": 1.8,
        "pts": 49.2,
        "value": 9.8,
        "matched": true,
        "matchName": "Keane"
      }
    ]
  },
  {
    "clubId": "7",
    "clubName": "Voodoo Vazza",
    "managerName": "Varun Kapoor",
    "totalPts": 1005.8,
    "playersCount": 11,
    "projectedCount": 11,
    "players": [
      {
        "playerId": 26,
        "name": "Kai Havertz",
        "webName": "Havertz",
        "position": "FWD",
        "fplTeam": "ARS",
        "fplPos": "FWD",
        "fplPrice": 7.5,
        "mins": 1902.0,
        "goals": 10.0,
        "assists": 3.8,
        "cleanSheets": 0.0,
        "bonus": 10.7,
        "yc": 3.6,
        "pts": 110.6,
        "value": 14.8,
        "matched": true,
        "matchName": "Havertz"
      },
      {
        "playerId": 456,
        "name": "Jacob J.Ramsey",
        "webName": "J.Ramsey",
        "position": "MID",
        "fplTeam": "NEW",
        "fplPos": "MID",
        "fplPrice": 5.0,
        "mins": 2413.0,
        "goals": 2.6,
        "assists": 4.3,
        "cleanSheets": 5.5,
        "bonus": 5.1,
        "yc": 7.3,
        "pts": 98.4,
        "value": 19.7,
        "matched": true,
        "matchName": "J.Ramsey"
      },
      {
        "playerId": 452,
        "name": "Bruno Bruno G.",
        "webName": "Bruno G.",
        "position": "MID",
        "fplTeam": "ARS",
        "fplPos": "MID",
        "fplPrice": 7.0,
        "mins": 1538.0,
        "goals": 4.0,
        "assists": 4.0,
        "cleanSheets": 7.0,
        "bonus": 7.6,
        "yc": 3.2,
        "pts": 92.0,
        "value": 13.1,
        "matched": true,
        "matchName": "Bruno G."
      },
      {
        "playerId": 32,
        "name": "Matty Cash",
        "webName": "Cash",
        "position": "DEF",
        "fplTeam": "AVL",
        "fplPos": "DEF",
        "fplPrice": 4.5,
        "mins": 3057.0,
        "goals": 2.5,
        "assists": 4.0,
        "cleanSheets": 8.7,
        "bonus": 7.1,
        "yc": 9.3,
        "pts": 118.2,
        "value": 26.3,
        "matched": true,
        "matchName": "Cash"
      },
      {
        "playerId": 482,
        "name": "Callum Hudson-Odoi",
        "webName": "Hudson-Odoi",
        "position": "MID",
        "fplTeam": "NFO",
        "fplPos": "MID",
        "fplPrice": 6.0,
        "mins": 616.0,
        "goals": 1.4,
        "assists": 1.6,
        "cleanSheets": 1.5,
        "bonus": 2.0,
        "yc": 0.6,
        "pts": 34.7,
        "value": 5.8,
        "matched": true,
        "matchName": "Hudson-Odoi"
      },
      {
        "playerId": 403,
        "name": "S\u00e1vio Savinho",
        "webName": "Savinho",
        "position": "MID",
        "fplTeam": "MCI",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 0.0,
        "goals": 0.0,
        "assists": 0.0,
        "cleanSheets": 0.0,
        "bonus": 0.0,
        "yc": 0.0,
        "pts": 0.0,
        "value": 0.0,
        "matched": true,
        "matchName": "Savinho"
      },
      {
        "playerId": 8,
        "name": "Riccardo Calafiori",
        "webName": "Calafiori",
        "position": "DEF",
        "fplTeam": "ARS",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 1638.0,
        "goals": 2.1,
        "assists": 1.7,
        "cleanSheets": 7.4,
        "bonus": 4.3,
        "yc": 3.4,
        "pts": 91.5,
        "value": 16.6,
        "matched": true,
        "matchName": "Calafiori"
      },
      {
        "playerId": 88,
        "name": "Michael Kayode",
        "webName": "Kayode",
        "position": "DEF",
        "fplTeam": "BRE",
        "fplPos": "DEF",
        "fplPrice": 4.5,
        "mins": 3137.0,
        "goals": 1.0,
        "assists": 3.6,
        "cleanSheets": 7.4,
        "bonus": 8.9,
        "yc": 8.5,
        "pts": 106.0,
        "value": 23.6,
        "matched": true,
        "matchName": "Kayode"
      },
      {
        "playerId": 10,
        "name": "Benjamin White",
        "webName": "White",
        "position": "DEF",
        "fplTeam": "ARS",
        "fplPos": "DEF",
        "fplPrice": 5.5,
        "mins": 1448.0,
        "goals": 0.8,
        "assists": 2.1,
        "cleanSheets": 6.5,
        "bonus": 4.2,
        "yc": 2.1,
        "pts": 78.6,
        "value": 14.3,
        "matched": true,
        "matchName": "White"
      },
      {
        "playerId": 557,
        "name": "Christos Tzolis",
        "webName": "Tzolis",
        "position": "MID",
        "fplTeam": "ARS",
        "fplPos": "MID",
        "fplPrice": 6.5,
        "mins": 2639.0,
        "goals": 7.5,
        "assists": 10.4,
        "cleanSheets": 12.0,
        "bonus": 9.9,
        "yc": 2.6,
        "pts": 154.1,
        "value": 23.7,
        "matched": true,
        "matchName": "Tzolis"
      },
      {
        "playerId": 496,
        "name": "Anton\u00edn Kinsky",
        "webName": "Kinsky",
        "position": "GK",
        "fplTeam": "TOT",
        "fplPos": "GK",
        "fplPrice": 4.5,
        "mins": 3192.0,
        "goals": 0.0,
        "assists": 0.1,
        "cleanSheets": 9.3,
        "bonus": 7.4,
        "yc": 3.3,
        "pts": 121.7,
        "value": 27.0,
        "matched": true,
        "matchName": "Kinsky"
      }
    ]
  }
];

export const POSITION_COLORS = {
  GK: '#e67e22',
  DEF: '#27ae60',
  MID: '#2980b9',
  FWD: '#c0392b',
};
